/**
 * Custom API error code values
 */
export enum ApiErrorCodeEnum {
  OK = 0,

  /**
   * The resource cannot be deleted because it has dependencies.
   */
  DELETION_BLOCKED_BY_DEPENDENCY = 3,

  /**
   * Tenant is not entitled to the requested feature flag.
   */
  FEATURE_NOT_ENTITLED = 4,

  /**
   * The auth-provider session email is not verified, so a renter account is not minted.
   */
  EMAIL_UNVERIFIED = 5,

  /**
   * The auth-provider user was deleted and the renter account was deleted.
   */
  ACCOUNT_DELETED = 6,

  /**
   * The named renter account is not a live account with a handle.
   */
  ACCOUNT_NOT_FOUND = 7,

  /**
   * A customer id on the agreement does not exist.
   */
  CUSTOMER_NOT_FOUND = 8,

  UNKNOWN = Number.MAX_SAFE_INTEGER,
}
